import React from 'react';
import { useLocation } from "react-router-dom";
// Zustand
import { useStore } from './zustand';
// Components
import Main from "./Main";
import BlockedUI from "./components/BlockedUI";
// Helpers
import queryString from 'query-string';
import { handleShadeStart } from "./utility/handleAppData";

const App = () => {
  // console.log("1a: /App.js");
  const location = useLocation();
  const appStatus = useStore(state => state.appStatus); // Going to rerender Component on appStatus change

  const handleAppSettings = React.useCallback(async () => {
    const params = queryString.parse(location.search);
    
    await handleShadeStart(params);

  }, [location.search]);

  React.useEffect(() => {
    handleAppSettings();
  }, [handleAppSettings]);

  return (
    <div className="App">
        { appStatus === "SHADE_READY" && <Main /> }
        { appStatus === "SHADE_BLOCKED" && <BlockedUI /> }
    </div>
  );
}

export default App;
